import { IconName, IconNames } from "@blueprintjs/icons";
import { PersistentBannerVariant } from "./types";

export const VARIANT_TO_ICON: Record<PersistentBannerVariant, IconName> = {
  [PersistentBannerVariant.INFO]: IconNames.INFO_SIGN,
  [PersistentBannerVariant.WARNING]: IconNames.WARNING_SIGN,
  [PersistentBannerVariant.SUCCESS]: IconNames.TICK_CIRCLE,
  [PersistentBannerVariant.DANGER]: IconNames.INFO_SIGN
};
